import React from "react";
import Close from "@Components/Icons/Close";
import PredictMascotIcon from "@Components/Icons/PredictMascot";
import InfoPopup from "@Components/InfoPopup";
import Button from "@Components/Button";
import BillReports from "@Components/Icons/TenderWelcome/BillReports";
import Done from "@Components/Icons/TenderWelcome/Done";
import Preferences from "@Components/Icons/TenderWelcome/Preferences";
import styles from "./index.module.scss";
import Step from "./Step";
import StepLine from "./StepLine";
import StepNumber from "./StepNumber";
export default class WelcomePopup extends React.Component {
    render() {
        const popup = (close) => {
            return (React.createElement("div", { className: styles.popup },
                React.createElement(Close, { onClick: close, size: "12px", color: "#98a2b3", className: styles.close }),
                React.createElement("div", { className: styles.header },
                    React.createElement(PredictMascotIcon, { className: styles.mascot }),
                    React.createElement("div", { className: styles.title },
                        React.createElement("span", { className: styles.highlightPrimary }, "Hello"),
                        ", before we start,",
                        React.createElement("br", null),
                        "here's what to expect next...")),
                React.createElement("div", { className: styles.body },
                    React.createElement(StepNumber, { label: "1", backgroundColor: "#0EABDB" }),
                    React.createElement(Step, { icon: React.createElement(Preferences, { size: "32px", noFill: true }), title: "Your Preferences", description: React.createElement(React.Fragment, null,
                            "You answer",
                            React.createElement("br", null),
                            "a few",
                            " ",
                            React.createElement("span", { style: {
                                    fontWeight: "bold",
                                    color: "#0EABDB",
                                } }, "questions")), background: "linear-gradient(180deg, #D6EEF5 0%, rgba(255, 255, 255) 56.46%)", stepNumber: 1 }),
                    React.createElement(StepLine, null),
                    React.createElement(StepNumber, { label: "2", backgroundColor: "#000000" }),
                    React.createElement(Step, { icon: React.createElement(BillReports, { size: "32px", noFill: true }), title: "Your Bill Reports", description: React.createElement(React.Fragment, null,
                            "You ",
                            React.createElement("b", null, "analyse"),
                            React.createElement("br", null),
                            "your Bill Reports"), background: "linear-gradient(180deg, rgb(234,234,234) 0%, rgba(255, 255, 255) 54.53%)", stepNumber: 2 }),
                    React.createElement(StepLine, null),
                    React.createElement(StepNumber, { label: "3", backgroundColor: "#00A555" }),
                    React.createElement(Step, { icon: React.createElement(Done, { size: "32px", noFill: true }), title: "You're Done", description: React.createElement(React.Fragment, null,
                            "Suppliers submit",
                            React.createElement("br", null),
                            React.createElement("span", { style: {
                                    fontWeight: "bold",
                                    color: "#00A555",
                                } }, "Proposals")), background: "linear-gradient(180deg, #D7F1E4 0%, rgba(255, 255, 255) 54.53%)", stepNumber: 3 })),
                React.createElement("div", { className: styles.buttonWrapper },
                    React.createElement(Button, { arrow: true, newCta: true, className: styles.button, click: this.props.onClose }, "LET'S GET STARTED"))));
        };
        return (React.createElement(InfoPopup, { trigger: this.props.open === true, content: popup, onClose: this.props.onClose, styles: {
                transition: "all 0.5s",
            }, overlayStyles: {
                backdropFilter: "blur(16px)",
                background: "#B7C2CD70",
            } }));
    }
}
